import { useNavigate } from 'react-router-dom';
import { useI18n } from '../i18n/useI18n';

export function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <div className="relative min-h-screen h-screen app-shell-bg text-text flex flex-col items-center justify-center overflow-hidden">
      <div className="blur-anchor" aria-hidden="true" />
      
      <div className="glass-lg p-10 md:p-16 rounded-[36px] text-center flex flex-col gap-6 max-w-md mx-4 z-10 items-center">
        <div className="text-8xl font-bold bg-clip-text text-transparent bg-gradient-to-br from-blue-400 to-purple-500">
          404
        </div>
        <div className="space-y-3">
          <h2 className="text-2xl font-semibold tracking-wide">{t('notFound.title')}</h2>
          <p className="text-text-muted text-base leading-relaxed">
            {t('notFound.desc')}
          </p>
        </div>
        
        <button 
          onClick={() => navigate('/')}
          className="primary-pill px-8 py-3 rounded-full font-bold text-lg hover:brightness-110 transition-all duration-300 mt-4"
        >
          {t('common.backHome')}
        </button>
      </div>
    </div>
  );
}
